import React from "react";
import { Row } from "react-bootstrap";
import DonutChart from "./DonutChart";

function DonutChartContainer(props) {
  const {
    annualLeaves,
    compensationLeaves,
    maternityLeave,
    sickLeaves,
    specialLeave,
    withoutPayLeave,
  } = props.leavesQuotaResponse;

  const leaveQuota = [
    {
      leaveType: "Annual",
      count: `${annualLeaves.remaining}/${annualLeaves.total}`,
      data: [
        {
          name: annualLeaves.taken,
          y: annualLeaves.taken,
          color: "#80ADEA",
        },
        {
          name: "",
          y: annualLeaves.remaining,
          color: "#F5F5F5",
        },
      ],
    },
    {
      leaveType: "Sick",
      count: `${sickLeaves.remaining}/${sickLeaves.total}`,
      data: [
        {
          name: sickLeaves.taken,
          y: sickLeaves.taken,
          color: "#53C2CE",
        },
        {
          name: "",
          y: sickLeaves.remaining,
          color: "#F5F5F5",
        },
      ],
    },
    {
      leaveType: "Compensation",
      count: `${compensationLeaves.remaining}/${compensationLeaves.total}`,
      data: [
        {
          name: compensationLeaves.taken,
          y: compensationLeaves.taken,
          color: "#A4716E",
        },
        {
          name: "",
          y: compensationLeaves.remaining,
          color: "#F5F5F5",
        },
      ],
    },
    {
      leaveType: "Without Pay",
      count: `${withoutPayLeave.remaining}/${withoutPayLeave.total}`,
      data: [
        {
          name: withoutPayLeave.taken,
          y: withoutPayLeave.taken,
          color: "#7F9742",
        },
        {
          name: "",
          y: withoutPayLeave.remaining,
          color: "#F5F5F5",
        },
      ],
    },

    {
      leaveType: "Maternity",
      count: `${maternityLeave.remaining}/${maternityLeave.total}`,
      data: [
        {
          name: maternityLeave.taken,
          y: maternityLeave.taken,
          color: "#AC7BBD",
        },
        {
          name: "",
          y: maternityLeave.remaining,
          color: "#F5F5F5",
        },
      ],
    },
    {
      leaveType: "Special",
      count: `${specialLeave.remaining}/${specialLeave.total}`,
      data: [
        {
          name: specialLeave.taken,
          y: specialLeave.taken,
          color: "#53C2CE",
        },
        {
          name: "",
          y: specialLeave.remaining,
          color: "#F5F5F5",
        },
      ],
    },
  ];
  return (
    <Row className="mx-1 col-md-12 mt-2 mt-lg-0 mt-md-0 leaveChartWrapper">
      {leaveQuota.map((item, index) => {
        return <DonutChart key={index} data={item} />;
      })}
    </Row>
  );
}

export default DonutChartContainer;
